import { Link, useNavigate } from "react-router-dom";
import { LogOut, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useBusiness } from "@/context/BusinessContext";

const ROLE_LABEL = { admin: "Admin", employee: "Staff", customer: "Customer" };

export const AppHeader = ({ links = [] }) => {
  const { user, logout } = useAuth();
  const { profile } = useBusiness();
  const navigate = useNavigate();

  return (
    <header data-testid="app-header" className="sticky top-0 z-40 backdrop-blur-xl bg-[#030712]/85 border-b border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2.5 min-w-0" data-testid="nav-home-link">
          <span className="grid place-items-center w-9 h-9 border glow-cyan text-cyan-300 shrink-0"><Truck className="w-4 h-4" /></span>
          <span className="font-display font-bold text-sm sm:text-base tracking-widest uppercase text-slate-100 truncate">{profile?.company_name || "Towing"}</span>
        </Link>
        <div className="flex items-center gap-2 sm:gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={l.testId} className="font-mono text-xs uppercase tracking-wider text-slate-400 hover:text-cyan-300 transition-colors">
              {l.label}
            </Link>
          ))}
          <span data-testid="user-role-badge" className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.2em] px-2 py-1 border border-[#FF007F]/50 text-[#FF007F]">
            {ROLE_LABEL[user?.role]}
          </span>
          <span className="hidden lg:inline font-mono text-xs text-slate-500" data-testid="header-user-email">{user?.email}</span>
          <Button
            data-testid="auth-signout-button"
            size="sm"
            variant="ghost"
            className="rounded-none font-mono text-xs uppercase text-slate-300 hover:bg-cyan-950/50 hover:text-cyan-300"
            onClick={async () => { await logout(); navigate("/"); }}
          >
            <LogOut className="w-4 h-4 sm:mr-1.5" /><span className="hidden sm:inline">Sign out</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
